module.exports = __webpack_public_path__ + "static/gallery-9-1b4fbef3aa1298373a4ed23d6ba059ac.jpg";